/* ==========================================================================
   KITSTERS · CONTACT - scroll reveal
   Design system §8: fire once via IntersectionObserver at threshold 0.15, then
   unobserve. Only `transform` + `opacity` are animated (the CSS owns both).
   Respects prefers-reduced-motion - the CSS only hides elements inside a
   `no-preference` query, so bailing out here leaves everything visible.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var targets = document.querySelectorAll('.kct [data-kct-reveal]');
    if (!targets.length) return;

    if (REDUCED.matches || !('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-revealed');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    function reveal(el) {
      el.classList.add('is-revealed');
      observer.unobserve(el);
    }

    /* Safety net - IntersectionObserver ALONE is not enough, and the failure mode
       is permanently invisible content, not a missing animation.
       IO only fires when an element's intersection ratio crosses a threshold, and
       it evaluates once per frame. A jump scroll takes an element from "below the
       viewport" (ratio 0) to "above the viewport" (ratio 0) inside a single frame,
       so no threshold is ever crossed and no callback ever runs - the element
       stays at `opacity: 0` for the rest of the page's life. This is not
       theoretical: measured on this page, jumping to the bottom left all three
       "Come Say Hi" panels invisible, so the indigo band rendered as an empty
       colour block. This page ships its own `#kct-form` anchor CTA, which does
       exactly that kind of jump.
       So: sweep on scroll (rAF-throttled, passive) and reveal anything that has
       reached or passed the viewport, whether or not IO noticed. */
    function sweep() {
      var pending = document.querySelectorAll('.kct [data-kct-reveal]:not(.is-revealed)');
      for (var i = 0; i < pending.length; i++) {
        if (pending[i].getBoundingClientRect().top < window.innerHeight) reveal(pending[i]);
      }
      if (!pending.length) window.removeEventListener('scroll', onScroll);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        sweep();
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* Stagger capped at 4 items per group so a long list never crawls in (§8). */
    Array.prototype.forEach.call(targets, function (el, index) {
      el.style.transitionDelay = (index % 4) * 80 + 'ms';
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
